// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6496":"e73d1535","7441":"c8640e42","7766":"e73d1535","7977":"1e2ea84c","9437":"66bddf09"}[chunkId] + ".chunk.css";
};